// src/data/districtData.js

const districtData = {
  "Province 1": {
    "Bhojpur": {
      local_level_units: [
        { name: "Bhojpur", postal_code: "57000", shipping_cost: 245 }
      ]
    },
    "Dhankuta": {
      local_level_units: [
        { name: "Dhankuta Bazaar", postal_code: "56800", shipping_cost: 270 },
        { name: "Pakhribas, Dhankuta", postal_code: "56802", shipping_cost: 220 }
      ]
    },
    "Ilam": {
      local_level_units: [
        { name: "Ilam Bazar", postal_code: "57300", shipping_cost: 245 },
        { name: "Phidim, Ilam", postal_code: "57400", shipping_cost: 245 },
        { name: "Pashupatinagar, Ilam", postal_code: "57306", shipping_cost: 245 },
        { name: "Mangalbare Ilam", postal_code: "57308", shipping_cost: 220 },
        { name: "Fikkal, Ilam", postal_code: "57310", shipping_cost: 245 },
        { name: "Shree Antu, Ilam", postal_code: "57312", shipping_cost: 245 }
      ]
    },
    "Jhapa": {
      local_level_units: [
        { name: "Birtamod, Jhapa", postal_code: "57208", shipping_cost: 220 },
        { name: "Damak, Jhapa", postal_code: "57207", shipping_cost: 220 },
        { name: "Kakarbhitta, Jhapa", postal_code: "57210", shipping_cost: 220 },
        { name: "Bhadrapur, Jhapa", postal_code: "57200", shipping_cost: 220 },
        { name: "Mechinagar, Jhapa", postal_code: "57205", shipping_cost: 220 },
        { name: "Bahundangi, Jhapa", postal_code: "57212", shipping_cost: 245 },
        { name: "Budhabare, Jhapa", postal_code: "57214", shipping_cost: 220 }
      ]
    },
    "Morang": {
      local_level_units: [
        { name: "Biratnagar, Morang", postal_code: "56600", shipping_cost: 220 },
        { name: "Urlabari, Morang", postal_code: "56615", shipping_cost: 220 },
        { name: "Belbari, Morang", postal_code: "56610", shipping_cost: 220 },
        { name: "Sundar Haraincha, Morang", postal_code: "56613", shipping_cost: 220 },
        { name: "Rangeli, Morang", postal_code: "56617", shipping_cost: 221 },
        { name: "Pathari, Morang", postal_code: "56619", shipping_cost: 220 },
        { name: "Kerabari Morang", postal_code: "56621", shipping_cost: 220 }
      ]
    },
    "Sunsari": {
      local_level_units: [
        { name: "Itahari, Sunsari", postal_code: "56700", shipping_cost: 220 },
        { name: "Dharan, Sunsari", postal_code: "56702", shipping_cost: 220 },
        { name: "Inaruwa, Sunsari", postal_code: "56705", shipping_cost: 220 },
        { name: "Duhabi, Sunsari", postal_code: "56707", shipping_cost: 220 },
        { name: "Ramdhuni, Sunsari", postal_code: "56709", shipping_cost: 220 },
        { name: "Dumra, Sunsari", postal_code: "56711", shipping_cost: 220 }
      ]
    },
    "Sankhuwasabha": {
      local_level_units: [
        { name: "Khandbari, Sankhuwasabha", postal_code: "56900", shipping_cost: 245 },
        { name: "Chainpur Sankhuwasabha", postal_code: "56902", shipping_cost: 270 },
        { name: "Madi, Sankhuwasabha", postal_code: "56905", shipping_cost: 220 }
      ]
    },
    "Terhathum": {
      local_level_units: [
        { name: "Myanglung, Terhathum", postal_code: "57100", shipping_cost: 245 },
        { name: "Terhathum Basantapur", postal_code: "57102", shipping_cost: 245 }
      ]
    },
    "Udayapur": {
      local_level_units: [
        { name: "Gaighat, Udayapur", postal_code: "56300", shipping_cost: 220 },
        { name: "Katari, Udayapur", postal_code: "56302", shipping_cost: 220 },
        { name: "Chaudandigadhi, Udayapur", postal_code: "56305", shipping_cost: 220 }
      ]
    }
  },
  "Madhesh Province": {
    "Bara": {
      local_level_units: [
        { name: "Kalaiya, Bara", postal_code: "44400", shipping_cost: 220 },
        { name: "Simara, Bara", postal_code: "44405", shipping_cost: 245 },
        { name: "Jitpur Simara, Bara", postal_code: "44407", shipping_cost: 220 },
        { name: "Kolhabi, Bara", postal_code: "44410", shipping_cost: 220 },
        { name: "Nijgadh, Bara", postal_code: "44412", shipping_cost: 220 }
      ]
    },
    "Dhanusha": {
      local_level_units: [
        { name: "Janakpur, Dhanusha", postal_code: "45600", shipping_cost: 220 },
        { name: "Dhanushadham, Dhanusha", postal_code: "45605", shipping_cost: 220 },
        { name: "Mithila, Dhanusha", postal_code: "45610", shipping_cost: 220 },
        { name: "Gaushala Mahottari, Dhanusha", postal_code: "45710", shipping_cost: 220 },
        { name: "Sabaila, Dhanusha", postal_code: "45615", shipping_cost: 220 }
      ]
    },
    "Mahottari": {
      local_level_units: [
        { name: "Jaleshwor, Mahottari", postal_code: "45700", shipping_cost: 220 },
        { name: "Bardibas, Mahottari", postal_code: "45705", shipping_cost: 220 },
        { name: "Gaushala, Mahottari", postal_code: "45710", shipping_cost: 220 },
        { name: "Matihani, Mahottari", postal_code: "45712", shipping_cost: 220 }
      ]
    },
    "Parsa": {
      local_level_units: [
        { name: "Birgunj, Parsa", postal_code: "44300", shipping_cost: 220 },
        { name: "Pokhariya, Parsa", postal_code: "44305", shipping_cost: 220 },
        { name: "Bahudaramai, Parsa", postal_code: "44310", shipping_cost: 220 },
        { name: "Parsagadhi, Parsa", postal_code: "44312", shipping_cost: 220 }
      ]
    },
    "Rautahat": {
      local_level_units: [
        { name: "Gaur, Rautahat", postal_code: "44500", shipping_cost: 220 },
        { name: "Chandrapur, Rautahat", postal_code: "44505", shipping_cost: 220 },
        { name: "Garuda, Rautahat", postal_code: "44510", shipping_cost: 220 },
        { name: "Brindaban, Rautahat", postal_code: "44512", shipping_cost: 220 }
      ]
    },
    "Saptari": {
      local_level_units: [
        { name: "Rajbiraj, Saptari", postal_code: "56400", shipping_cost: 220 },
        { name: "Hanumannagar, Saptari", postal_code: "56405", shipping_cost: 220 },
        { name: "Kanchanrup, Saptari", postal_code: "56410", shipping_cost: 220 },
        { name: "Khadak, Saptari", postal_code: "56412", shipping_cost: 220 }
      ]
    },
    "Sarlahi": {
      local_level_units: [
        { name: "Malangwa, Sarlahi", postal_code: "45800", shipping_cost: 220 },
        { name: "Haripurwa, Sarlahi", postal_code: "45805", shipping_cost: 220 },
        { name: "Ishwarpur, Sarlahi", postal_code: "45810", shipping_cost: 220 },
        { name: "Barahathawa, Sarlahi", postal_code: "45812", shipping_cost: 220 }
      ]
    },
    "Siraha": {
      local_level_units: [
        { name: "Lahan, Siraha", postal_code: "56500", shipping_cost: 220 },
        { name: "Siraha", postal_code: "56505", shipping_cost: 220 },
        { name: "Golbazar, Siraha", postal_code: "56510", shipping_cost: 220 },
        { name: "Mirchaiya, Siraha", postal_code: "56512", shipping_cost: 220 }
      ]
    }
  },
  "Bagmati Province": {
    "Bhaktapur": {
      local_level_units: [
        { name: "Bhaktapur", postal_code: "44800", shipping_cost: 220 },
        { name: "Suryabinayak, Bhaktapur", postal_code: "44810", shipping_cost: 220 },
        { name: "Changunarayan, Bhaktapur", postal_code: "44815", shipping_cost: 220 }
      ]
    },
    "Chitwan": {
      local_level_units: [
        { name: "Bharatpur, Chitwan", postal_code: "44200", shipping_cost: 220 },
        { name: "Ratnanagar, Chitwan", postal_code: "44205", shipping_cost: 220 },
        { name: "Khairahani, Chitwan", postal_code: "44210", shipping_cost: 220 },
        { name: "Rapti, Chitwan", postal_code: "44212", shipping_cost: 220 },
        { name: "Madi, Chitwan", postal_code: "44215", shipping_cost: 220 }
      ]
    },
    "Dhading": {
      local_level_units: [
        { name: "Dhading Besi", postal_code: "45100", shipping_cost: 220 },
        { name: "Nilkantha, Dhading", postal_code: "45105", shipping_cost: 220 },
        { name: "Khaniyabas, Dhading", postal_code: "45110", shipping_cost: 220 }
      ]
    },
    "Dolakha": {
      local_level_units: [
        { name: "Charikot, Dolakha", postal_code: "45500", shipping_cost: 245 },
        { name: "Jiri, Dolakha", postal_code: "45505", shipping_cost: 245 },
        { name: "Bhimeshwar, Dolakha", postal_code: "45510", shipping_cost: 245 }
      ]
    },
    "Kathmandu": {
      local_level_units: [
        { name: "Kathmandu Metro", postal_code: "44600", shipping_cost: 220 },
        { name: "Chabahil, Kathmandu", postal_code: "44620", shipping_cost: 220 },
        { name: "Koteshwor, Kathmandu", postal_code: "44615", shipping_cost: 220 },
        { name: "Kalanki, Kathmandu", postal_code: "44625", shipping_cost: 220 },
        { name: "Tokha, Kathmandu", postal_code: "44630", shipping_cost: 220 },
        { name: "Kirtipur, Kathmandu", postal_code: "44635", shipping_cost: 220 },
        { name: "Tinkune, Kathmandu", postal_code: "44640", shipping_cost: 220 },
        { name: "Newroad, Kathmandu", postal_code: "44645", shipping_cost: 220 },
        { name: "Naya Buspark, Kathmandu", postal_code: "44650", shipping_cost: 220 }
      ]
    },
    "Kavrepalanchok": {
      local_level_units: [
        { name: "Banepa, Kavrepalanchok", postal_code: "45205", shipping_cost: 220 },
        { name: "Dhulikhel, Kavrepalanchok", postal_code: "45200", shipping_cost: 220 },
        { name: "Panauti, Kavrepalanchok", postal_code: "45210", shipping_cost: 220 },
        { name: "Panchkhal, Kavrepalanchok", postal_code: "45215", shipping_cost: 245 }
      ]
    },
    "Lalitpur": {
      local_level_units: [
        { name: "Patan, Lalitpur", postal_code: "44700", shipping_cost: 220 },
        { name: "Satdobato, Lalitpur", postal_code: "44710", shipping_cost: 220 },
        { name: "Godawari, Lalitpur", postal_code: "44715", shipping_cost: 220 },
        { name: "Mahalaxmi, Lalitpur", postal_code: "44720", shipping_cost: 220 },
        { name: "Lubhu, Lalitpur", postal_code: "44725", shipping_cost: 220 }
      ]
    },
    "Nuwakot": {
      local_level_units: [
        { name: "Bidur, Nuwakot", postal_code: "44900", shipping_cost: 220 },
        { name: "Belkotgadhi, Nuwakot", postal_code: "44905", shipping_cost: 220 },
        { name: "Kakani, Nuwakot", postal_code: "44910", shipping_cost: 220 }
      ]
    },
    "Ramechhap": {
      local_level_units: [
        { name: "Manthali, Ramechhap", postal_code: "45400", shipping_cost: 245 },
        { name: "Ramechhap Bazar", postal_code: "45405", shipping_cost: 245 }
      ]
    },
    "Rasuwa": {
      local_level_units: [
        { name: "Dhunche, Rasuwa", postal_code: "45010", shipping_cost: 245 },
        { name: "Gosaikunda, Rasuwa", postal_code: "45015", shipping_cost: 245 }
      ]
    },
    "Sindhuli": {
      local_level_units: [
        { name: "Sindhuli, Sindhuli", postal_code: "45900", shipping_cost: 220 },
        { name: "Kamalamai, Sindhuli", postal_code: "45905", shipping_cost: 220 },
        { name: "Dudhouli, Sindhuli", postal_code: "45910", shipping_cost: 220 }
      ]
    },
    "Sindhupalchok": {
      local_level_units: [
        { name: "Chautara, Sindhupalchok", postal_code: "45300", shipping_cost: 245 },
        { name: "Bahrabise, Sindhupalchok", postal_code: "45305", shipping_cost: 245 },
        { name: "Melamchi, Sindhupalchok", postal_code: "45310", shipping_cost: 245 }
      ]
    }
  },
  "Gandaki Province": {
    "Baglung": {
      local_level_units: [
        { name: "Baglung Bazar, ", postal_code: "53300", shipping_cost: 220 },
        { name: "Galkot, Baglung", postal_code: "53305", shipping_cost: 245 },
        { name: "Jaimuni, Baglung", postal_code: "53310", shipping_cost: 220 },
        { name: "Burtibang, Baglung", postal_code: "53315", shipping_cost: 245 }
      ]
    },
    "Gorkha": {
      local_level_units: [
        { name: "Gorkha Bazar", postal_code: "34000", shipping_cost: 220 },
        { name: "Palungtar, Gorkha", postal_code: "34005", shipping_cost: 220 },
        { name: "Siranchok, Gorkha", postal_code: "34010", shipping_cost: 220 },
        { name: "Manakamana, Gorkha", postal_code: "34015", shipping_cost: 245 }
      ]
    },
    "Kaski": {
      local_level_units: [
        { name: "Pokhara, Kaski", postal_code: "33700", shipping_cost: 220 },
        { name: "Lekhnath, Kaski", postal_code: "33715", shipping_cost: 220 },
        { name: "Hemja, Kaski", postal_code: "33720", shipping_cost: 220 },
        { name: "Naudanda Kaski", postal_code: "33725", shipping_cost: 220 },
        { name: "Sarangkot, Kaski", postal_code: "33730", shipping_cost: 220 }
      ]
    },
    "Lamjung": {
      local_level_units: [
        { name: "Besisahar, Lamjung", postal_code: "33600", shipping_cost: 220 },
        { name: "Sundarbazar, Lamjung", postal_code: "33605", shipping_cost: 220 },
        { name: "Dordi, Lamjung", postal_code: "33610", shipping_cost: 220 }
      ]
    },
    "Manang": {
      local_level_units: [
        { name: "Chame, Manang", postal_code: "33500", shipping_cost: 270 },
        { name: "Manang, Manang", postal_code: "33505", shipping_cost: 270 }
      ]
    },
    "Mustang": {
      local_level_units: [
        { name: "Jomsom, Mustang", postal_code: "33100", shipping_cost: 270 },
        { name: "Lomanthang, Mustang", postal_code: "33105", shipping_cost: 270 }
      ]
    },
    "Myagdi": {
      local_level_units: [
        { name: "Beni, Myagdi", postal_code: "53400", shipping_cost: 220 },
        { name: "Annapurna, Myagdi", postal_code: "53405", shipping_cost: 220 },
        { name: "Darbang Myagdi", postal_code: "53410", shipping_cost: 220 }
      ]
    },
    "Nawalpur": {
      local_level_units: [
        { name: "Kawasoti, Nawalpur", postal_code: "33000", shipping_cost: 220 },
        { name: "Madhyabindu, Nawalpur", postal_code: "33005", shipping_cost: 220 },
        { name: "Bardaghat, Nawalpur", postal_code: "33010", shipping_cost: 220 }
      ]
    },
    "Parbat": {
      local_level_units: [
        { name: "Kushma, Parbat", postal_code: "53200", shipping_cost: 220 },
        { name: "Phalebas, Parbat", postal_code: "53205", shipping_cost: 245 },
        { name: "Jaljala, Parbat", postal_code: "53210", shipping_cost: 245 }
      ]
    },
    "Syangja": {
      local_level_units: [
        { name: "Putalibazar, Syangja", postal_code: "33800", shipping_cost: 220 },
        { name: "Waling, Syangja", postal_code: "33805", shipping_cost: 220 },
        { name: "Chapakot, Syangja", postal_code: "33810", shipping_cost: 220 }
      ]
    },
    "Tanahun": {
      local_level_units: [
        { name: "Damauli, Tanahun", postal_code: "33900", shipping_cost: 220 },
        { name: "Shuklagandaki, Tanahun", postal_code: "33905", shipping_cost: 220 },
        { name: "Bhanu, Tanahun", postal_code: "33910", shipping_cost: 220 }
      ]
    }
  },
  "Lumbini Province": {
    "Arghakhanchi": {
      local_level_units: [
        { name: "Sandhikharka, Arghakhanchi", postal_code: "32700", shipping_cost: 245 },
        { name: "Sitganga, Arghakhanchi", postal_code: "32705", shipping_cost: 245 }
      ]
    },
    "Banke": {
      local_level_units: [
        { name: "Nepalgunj, Banke", postal_code: "52800", shipping_cost: 220 },
        { name: "Kohalpur, Banke", postal_code: "52805", shipping_cost: 220 },
        { name: "Khajura, Banke", postal_code: "52810", shipping_cost: 220 },
        { name: "Narainapur Banke", postal_code: "52815", shipping_cost: 220 }
      ]
    },
    "Bardiya": {
      local_level_units: [
        { name: "Gulariya, Bardiya", postal_code: "52900", shipping_cost: 220 },
        { name: "Rajapur, Bardiya", postal_code: "52905", shipping_cost: 220 },
        { name: "Madhuwan, Bardiya", postal_code: "52910", shipping_cost: 220 },
        { name: "Bhajani, Bardiya", postal_code: "52915", shipping_cost: 220 }
      ]
    },
    "Dang": {
      local_level_units: [
        { name: "Tulsipur, Dang", postal_code: "52405", shipping_cost: 220 },
        { name: "Ghorahi, Dang", postal_code: "52400", shipping_cost: 220 },
        { name: "Lamahi, Dang", postal_code: "52410", shipping_cost: 220 },
        { name: "Shaktikhor, Dang", postal_code: "52415", shipping_cost: 220 }
      ]
    },
    "Gulmi": {
      local_level_units: [
        { name: "Tamghas, Gulmi", postal_code: "32600", shipping_cost: 245 },
        { name: "Resunga, Gulmi", postal_code: "32605", shipping_cost: 245 },
        { name: "Chandrakot, Gulmi", postal_code: "32610", shipping_cost: 245 },
        { name: "Ridi, Gulmi", postal_code: "32615", shipping_cost: 245 }
      ]
    },
    "Kapilvastu": {
      local_level_units: [
        { name: "Taulihawa, Kapilvastu", postal_code: "32800", shipping_cost: 220 },
        { name: "Banganga, Kapilvastu", postal_code: "32805", shipping_cost: 220 },
        { name: "Maharajgunj, Kapilvastu", postal_code: "32810", shipping_cost: 220 },
        { name: "Khairhani Rupandehi", postal_code: "32815", shipping_cost: 220 }
      ]
    },
    "Palpa": {
      local_level_units: [
        { name: "Tansen, Palpa", postal_code: "32500", shipping_cost: 220 },
        { name: "Rampur, Palpa", postal_code: "32505", shipping_cost: 245 },
        { name: "Rainadevi, Palpa", postal_code: "32510", shipping_cost: 220 }
      ]
    },
    "Pyuthan": {
      local_level_units: [
        { name: "Pyuthan Khalanga, Pyuthan", postal_code: "52300", shipping_cost: 220 },
        { name: "Sworgadwari, Pyuthan", postal_code: "52305", shipping_cost: 220 }
      ]
    },
    "Rolpa": {
      local_level_units: [
        { name: "Liwang, Rolpa", postal_code: "52200", shipping_cost: 270 },
        { name: "Runtigadhi, Rolpa", postal_code: "52205", shipping_cost: 270 }
      ]
    },
    "Rukum East": {
      local_level_units: [
        { name: "Rukumkot, Rukum East", postal_code: "52100", shipping_cost: 270 },
        { name: "Putha Uttarganga, Rukum East", postal_code: "52105", shipping_cost: 270 }
      ]
    },
    "Rupandehi": {
      local_level_units: [
        { name: "Butwal, Rupandehi", postal_code: "32905", shipping_cost: 220 },
        { name: "Bhairahawa, Rupandehi", postal_code: "32900", shipping_cost: 220 },
        { name: "Lumbini, Rupandehi", postal_code: "32910", shipping_cost: 220 },
        { name: "Siddharthanagar, Rupandehi", postal_code: "32915", shipping_cost: 220 },
        { name: "Manigram, Rupandehi", postal_code: "32920", shipping_cost: 220 },
        { name: "Kotihawa, Rupandehi", postal_code: "32925", shipping_cost: 220 }
      ]
    }
  },
  "Karnali Province": {
    "Dailekh": {
      local_level_units: [
        { name: "Dailekh Bazaar", postal_code: "51600", shipping_cost: 245 },
        { name: "Dullu, Dailekh", postal_code: "51605", shipping_cost: 245 },
        { name: "Aathabis, Dailekh", postal_code: "51610", shipping_cost: 245 }
      ]
    },
    "Dolpa": {
      local_level_units: [
        { name: "Dunai, Dolpa", postal_code: "51300", shipping_cost: 270 },
        { name: "Tripurasundari, Dolpa", postal_code: "51305", shipping_cost: 270 }
      ]
    },
    "Humla": {
      local_level_units: [
        { name: "Simikot, Humla", postal_code: "51000", shipping_cost: 270 },
        { name: "Sarkegad, Humla", postal_code: "51005", shipping_cost: 270 }
      ]
    },
    "Jajarkot": {
      local_level_units: [
        { name: "Jajarkot Khalanga", postal_code: "51700", shipping_cost: 270 },
        { name: "Chhedagad, Jajarkot", postal_code: "51705", shipping_cost: 270 }
      ]
    },
    "Jumla": {
      local_level_units: [
        { name: "Jumla", postal_code: "51100", shipping_cost: 270 },
        { name: "Tila, Jumla", postal_code: "51105", shipping_cost: 270 }
      ]
    },
    "Kalikot": {
      local_level_units: [
        { name: "Manma, Kalikot", postal_code: "51200", shipping_cost: 270 },
        { name: "Raskot, Kalikot", postal_code: "51205", shipping_cost: 270 }
      ]
    },
    "Mugu": {
      local_level_units: [
        { name: "Gamgadhi, Mugu", postal_code: "51400", shipping_cost: 270 },
        { name: "Soru, Mugu", postal_code: "51405", shipping_cost: 270 }
      ]
    },
    "Rukum West": {
      local_level_units: [
        { name: "Musikot, Rukum West", postal_code: "52000", shipping_cost: 270 },
        { name: "Chaurjahari, Rukum West", postal_code: "52005", shipping_cost: 270 }
      ]
    },
    "Salyan": {
      local_level_units: [
        { name: "Salyan Khalanga", postal_code: "51800", shipping_cost: 245 },
        { name: "Bagchaur, Salyan", postal_code: "51805", shipping_cost: 245 }
      ]
    },
    "Surkhet": {
      local_level_units: [
        { name: "Birendranagar, Surkhet", postal_code: "52500", shipping_cost: 120 },
        { name: "Chinchu, Surkhet", postal_code: "52505", shipping_cost: 120 },
        { name: "Mehelkuna, Surkhet", postal_code: "52510", shipping_cost: 120 },
        { name: "Gurbhakot, Surkhet", postal_code: "52515", shipping_cost: 120 }
      ]
    }
  },
  "Sudurpashchim Province": {
    "Achham": {
      local_level_units: [
        { name: "Mangalsen, Achham", postal_code: "50700", shipping_cost: 270 },
        { name: "Kamal Bazar, Achham", postal_code: "50705", shipping_cost: 270 }
      ]
    },
    "Baitadi": {
      local_level_units: [
        { name: "Patan Baitadi", postal_code: "50205", shipping_cost: 270 },
        { name: "Dasharathchand, Baitadi", postal_code: "50200", shipping_cost: 270 }
      ]
    },
    "Bajhang": {
      local_level_units: [
        { name: "Chainpur Bajhang", postal_code: "50500", shipping_cost: 270 },
        { name: "Bungal, Bajhan", postal_code: "50505", shipping_cost: 270 }
      ]
    },
    "Bajura": {
      local_level_units: [
        { name: "Martadi, Bajura", postal_code: "50600", shipping_cost: 270 },
        { name: "Tribeni, Bajura", postal_code: "50605", shipping_cost: 270 }
      ]
    },
    "Dadeldhura": {
      local_level_units: [
        { name: "Amargadhi, Dadeldhura", postal_code: "50100", shipping_cost: 270 },
        { name: "Parshuram, Dadeldhura", postal_code: "50105", shipping_cost: 270 }
      ]
    },
    "Darchula": {
      local_level_units: [
        { name: "Darchula Khalanga", postal_code: "50400", shipping_cost: 270 },
        { name: "Shailyashikhar, Darchula", postal_code: "50405", shipping_cost: 270 }
      ]
    },
    "Doti": {
      local_level_units: [
        { name: "Dipayal Silgadhi, Doti", postal_code: "50800", shipping_cost: 270 },
        { name: "Shikhar, Doti", postal_code: "50805", shipping_cost: 270 }
      ]
    },
    "Kailali": {
      local_level_units: [
        { name: "Dhangadhi, Kailali", postal_code: "52700", shipping_cost: 220 },
        { name: "Tikapur, Kailali", postal_code: "52705", shipping_cost: 220 },
        { name: "Attariya, Kailali", postal_code: "52715", shipping_cost: 220 },
        { name: "Lamki Chuha, Kailali", postal_code: "52720", shipping_cost: 220 },
        { name: "Phulbari Kailali", postal_code: "52725", shipping_cost: 220 },
        { name: "Jugeda Kailali", postal_code: "52730", shipping_cost: 220 }
      ]
    },
    "Kanchanpur": {
      local_level_units: [
        { name: "Mahendranagar, Kanchanpur", postal_code: "52600", shipping_cost: 245 },
        { name: "Punarbas, Kanchanpur", postal_code: "52605", shipping_cost: 245 },
        { name: "Belauri, Kanchanpur", postal_code: "52610", shipping_cost: 245 },
        { name: "Bhimdatta, Kanchanpur", postal_code: "52615", shipping_cost: 245 }
      ]
    }
  }
};

export default districtData;